<template>
  <v-app>
    <v-main class="splash-container">
       <v-container fill-height class="d-flex flex-column">
<div class="logo-wrapper">
          <v-img
            src="@/assets/logoY.png" max-width="300" class="animate-logo mx-auto"
          />
        </div>
        <div class="text-wrapper">
          <p class="white--text text-h6">
            Cargando Portal Empresarial...
          </p>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'Splash',
  mounted() {
    // Esperar 1.5s y decidir a dónde ir
    setTimeout(() => {
      const token = localStorage.getItem('token')
      if (token) {
        this.$router.replace('/home')
      } else {
        this.$router.replace('/login')
      }
    }, 1500)
  }
}
</script>

<style scoped>
.splash-container {
  background: linear-gradient(135deg, #fbfbfc, #42a5f5);
}
/* Empuja el logo hacia abajo sin pegarlo */
.logo-wrapper {
  margin-top: 380px;   /* AJUSTA este valor */
}

/* Empuja el texto hacia abajo */
.text-wrapper {
  margin-top: auto;
  margin-bottom: 380px;
  text-align: center;
}

@keyframes pulse {
  0% { transform: scale(1); opacity: 0.7; }
  50% { transform: scale(1.1); opacity: 1; }
  100% { transform: scale(1); opacity: 0.7; }
}

.animate-logo {
  animation: pulse 1.5s infinite;
}
</style>
